export enum FieldTypeEnum {
  LABEL,
  LABEL_PERCENTAGE,
  LABEL_CURRENCY,
  LABEL_DATE,
  LABEL_DATE_TIME,
  INPUT,
  SELECT,
  CHECKBOX,
  RADIO,
  TEXTAREA,
  IMAGE,
  LABEL_FLAG,
  COLOR,
  LABEL_COLORED_BADGE
}
